var Model = require("../types/Model.js");
var xtend = require("xtend");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

var STORAGE_PREFIX = "personal_section_views";

module.exports = Model({
	name: "sectionupdateviews",
	init: init,
	triggers: triggers,
	listeners: listeners,
	load: load,
});

function init() {
	this.load();
}

function listeners() {
	return {
		"activegroupformsubmission:viewed": update,
		"ownreminders:viewed": update,
		"activeownformsubmission:viewed": update,
		"accountinvites:viewed": update,
	};
}

function triggers() {
	return {
		"update": update
	};
}

function load() {
	return AsyncStorage.getItem(STORAGE_PREFIX).then(function (raw) {
		if (!raw) raw = "{}";
		var parsed = {};
		try {
			parsed = JSON.parse(raw);
		} catch (e) {
			// Whatever
		}
		this.push(parsed);
	}.bind(this));

}

function update(data) {
	var section = data.section;
	var timestamp = data.timestamp;

	var existing = this.data;
	var updates = {};
	updates[section] = timestamp;

	var updated = xtend(existing, updates);

	AsyncStorage.setItem(STORAGE_PREFIX, JSON.stringify(updated));

	this.push(updated);
}
